export type PasswordOptions = {
  length?: number;
  numbers?: boolean;
  upper?: boolean;
  lower?: boolean;
  symbols?: boolean;
  avoidAmbiguous?: boolean;
};

const DEFAULTS: Required<PasswordOptions> = {
  length: 16,
  numbers: true,
  upper: true,
  lower: true,
  symbols: true,
  avoidAmbiguous: true,
};

const AMBIGUOUS = 'Il1O0`"\'|\\/.,:;()[]{}<>';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const NUMBERS = '0123456789';
const SYMBOLS = `!@#$%^&*()-_=+[]{};:,.<>?/~\``;

function secureRandomBytes(n: number): Uint8Array {
  if (!window?.crypto?.getRandomValues) {
    throw new Error('API window.crypto.getRandomValues não suportada neste ambiente.');
  }
  const arr = new Uint8Array(n);
  window.crypto.getRandomValues(arr);
  return arr;
}

export function generatePassword(opts?: PasswordOptions): string {
  const o = { ...DEFAULTS, ...(opts || {}) };

  let alphabet = '';
  if (o.lower) alphabet += LOWER;
  if (o.upper) alphabet += UPPER;
  if (o.numbers) alphabet += NUMBERS;
  if (o.symbols) alphabet += SYMBOLS;
  if (o.avoidAmbiguous) {
    alphabet = alphabet
      .split('')
      .filter(c => !AMBIGUOUS.includes(c))
      .join('');
  }

  if (!alphabet.length) {
    throw new Error('O alfabeto está vazio — habilite pelo menos um tipo de caractere.');
  }

  const bytes = secureRandomBytes(o.length);
  const result: string[] = [];
  const alphaLen = alphabet.length;
  const maxAcceptable = Math.floor(256 / alphaLen) * alphaLen;

  let i = 0;
  while (result.length < o.length) {
    if (i >= bytes.length) {
      bytes.set(secureRandomBytes(o.length));
      i = 0;
    }
    const v = bytes[i++];
    if (v >= maxAcceptable) continue;
    result.push(alphabet[v % alphaLen]);
  }

  return result.join('');
}
